export { default } from "./TermsContent";
